// Platform promo codes & gift cards — the data-testid registry.
//
// The super-admin Gift & Promo screen, the signup code field, the plan-change review and
// the Billing redeem card render these; the jest suites and the browser journey read them.
// Parameterised ids are functions of the row id or the field scope so the two sides
// cannot disagree on a separator.
// Contract: docs/payment-module/platform-offers-api-contract.md §8.1.

export const PLATFORM_OFFERS = Object.freeze({
  // super admin — HqGiftPromo.jsx
  page: "hq-gift-promo", tabPromos: "tab-promos", tabGifts: "tab-gifts",
  newPromo: "new-promo", promoForm: "promo-form", promoSubmit: "promo-submit",
  promoField: (name) => `promo-field-${name}`,          // code, discount_type, percent, amount, currency, duration, duration_in_months, max_uses, expires_at, plan_ids, description
  promoRow: (id) => `promo-row-${id}`,
  promoDescription: (id) => `promo-description-${id}`,
  promoCreated: (id) => `promo-created-${id}`,
  promoToggleActive: (id) => `promo-toggle-active-${id}`,
  promoEdit: (id) => `promo-edit-${id}`,
  promoRedemptions: (id) => `promo-redemptions-${id}`,
  newGift: "new-gift", giftForm: "gift-form", giftSubmit: "gift-submit",
  giftField: (name) => `gift-field-${name}`,            // amount, currency, recipient_email, recipient_name, message, locale, expires_at
  giftRow: (id) => `gift-row-${id}`,
  giftMessage: (id) => `gift-message-${id}`,          // data-empty = "true" when the card carries no message
  giftCreated: (id) => `gift-created-${id}`,
  giftStatus: (id) => `gift-status-${id}`,              // data-status = the card status
  giftDelivery: (id) => `gift-delivery-${id}`,          // data-delivered = "true" | "false"
  giftResend: (id) => `gift-resend-${id}`,
  giftVoid: (id) => `gift-void-${id}`,
  giftVoidReason: "gift-void-reason", giftVoidConfirm: "gift-void-confirm",
  giftRedemptions: (id) => `gift-redemptions-${id}`,
  redemptionsDrawer: "redemptions-drawer",
  redemptionRow: (id) => `redemption-row-${id}`,
  // signup + billing — shared CodeField
  codeField: (scope) => `code-field-${scope}`,          // scope: signup-promo | signup-giftcard | plan-change | billing-redeem
  codeInput: (scope) => `code-input-${scope}`,
  codeApply: (scope) => `code-apply-${scope}`,
  codeRemove: (scope) => `code-remove-${scope}`,
  codeResult: (scope) => `code-result-${scope}`,        // data-kind = promo | giftcard
  codeError: (scope) => `code-error-${scope}`,
  signupSummaryDiscount: "signup-summary-discount",
  signupSummaryCredit: "signup-summary-credit",
  billingRedeemCard: "billing-redeem-card",
  billingRedeemSubmit: "billing-redeem-submit",
  billingRedemptions: "billing-redemptions",
  billingRedemptionRow: (id) => `billing-redemption-${id}`,
  // plan-change review step — PlanChangeReview.jsx (the promo is previewed against the
  // TARGET plan, so the change is chosen first and confirmed here)
  planChangeReview: "plan-change-review",
  planChangeConfirm: "plan-change-confirm",
  planChangeCancel: "plan-change-cancel",
  planChangePromoTrialNote: "plan-change-promo-trial-note",
});
